import { useState, useContext } from 'react'
import {
  Popover,
  InputBase,
  IconButton,
  makeStyles,
  FormControl,
  Select,
} from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { Context } from '../../context'

const useStyles = makeStyles((theme) => ({
  popover: {
    backgroundColor: theme.palette.primary.main,
    height: 140,
    width: 500,
    padding: 23,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
  },
  whiteField: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: 'white',
    fontSize: 16,
    width: 280,
    padding: '5px 12px 5px 12px',
    display: 'flex',
    flexDirection: 'row',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  whiteFieldSelect: {
    borderRadius: 4,
    backgroundColor: 'white',
    fontSize: 16,
    marginRight: theme.spacing(1),
  },
}))

const TrackingPopover = ({ children }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [trackingNo, setTrackingNo] = useState(null)
  const [trackingMode, setTrackingMode] = useState('domestic')

  const { onRouting } = useContext(Context)

  const classes = useStyles()

  const { t } = useTranslation('header')
  const Router = useRouter()

  const handleClick = (e) => {
    setAnchorEl(e.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleSearch = (mode, value) => {
    if (value === null || value === '') {
      onRouting('/tracking')
    } else {
      onRouting('/tracking', `mode=${mode}&tracking_code=${value}`, {
        shallow: true,
      })
      handleClose()
    }
  }

  const handlePressEnter = (e) => {
    if (e.keyCode == 13) {
      handleSearch(trackingMode, trackingNo)
    }
  }

  const handleInputChange = (e) => {
    setTrackingNo(e.target.value)
  }

  const handleSearchClick = () => {
    handleSearch(trackingMode, trackingNo)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'tracking-popover' : undefined

  return (
    <>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          onClick: handleClick,
          'aria-describedby': id,
          'aria-haspopup': true,
        })
      })}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: -30,
          horizontal: 'left',
        }}
        elevation={2}
      >
        <div className={classes.popover}>
          <span style={{ color: 'white' }}>{t('track-status')}</span>
          <div className={classes.row}>
            <div className={classes.whiteFieldSelect}>
              <FormControl variant="outlined">
                <Select
                  native
                  value={trackingMode}
                  onChange={(e) => setTrackingMode(e.target.value)}
                  inputProps={{
                    name: 'trackingMode',
                    id: 'tracking-mode-select',
                  }}
                  style={{
                    height: 44,
                  }}
                >
                  <option value="domestic">{t('domestic')}</option>
                  <option value="inter">{t('inter')}</option>
                </Select>
              </FormControl>
            </div>
            <div className={classes.whiteField}>
              <InputBase
                fullWidth
                onChange={handleInputChange}
                onKeyDown={handlePressEnter}
                placeholder={t('fill-tracking-no')}
              />
              <IconButton onClick={handleSearchClick} style={{ padding: 0 }}>
                <SearchIcon color="primary" />
              </IconButton>
            </div>
          </div>
        </div>
      </Popover>
    </>
  )
}

export default TrackingPopover
